var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 31.98",
    style: {
      enableBackground: "new 0 0 32 31.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#202843",
    d: "M31.13,21.13C34,12.78,29.5,3.65,21.15,0.84S3.74,2.47,0.87,10.82s1.63,17.42,9.98,20.29 S28.33,29.54,31.13,21.13L31.13,21.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFCA4C",
    d: "M2.5,24.52c2.48-1.17,10.96-5.35,12.59-6.33c1.37-0.78,3.39-1.96,3.39-1.96L19.33,18l1.3,8.68l0.98-0.59 l0.65-12.13c2.02-1.3,3.85-2.54,5.74-3.85c0.72-0.46,1.37-0.98,2.09-1.44c-0.26-0.46-0.46-0.85-0.78-1.3l-2.15,1.11 c-2.09,0.98-4.04,1.89-6.2,3.07L10.13,5.99L9.15,6.58l6.91,5.48l1.11,1.63l0,0c0,0-2.02,1.17-3.39,1.96 c-1.76,0.98-9.65,6.26-11.87,7.83C2.04,23.8,2.3,24.13,2.5,24.52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpedia);
export default __webpack_public_path__ + "static/media/expedia.4704a2ae4801f18daa41088727c6f296.svg";
export { ForwardRef as ReactComponent };